import { render, staticRenderFns } from "./OrderInfoBlock.vue?vue&type=template&id=bc46e71c&"
import script from "./OrderInfoBlock.vue?vue&type=script&lang=js&"
export * from "./OrderInfoBlock.vue?vue&type=script&lang=js&"
import style0 from "./OrderInfoBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports